import SocialLinks from "components/social-links";
import HeartIcon from "lib/assets/svg/heart";
import { Link } from "react-router-dom";
import { Links, officeContactDetails } from "config/config";
import { KW_LOGO } from "constant";
import {
  COMPANY_NAME,
  COMPANY_URL,
  COPYRIGHT_SYMBOL,
  KALYANAWARAN_URL,
  RIGHT_RESERVED,
  WEBSITE_NAME,
} from "constant/footerConst";
import { trackEvent, AnalyticsEvents } from "utils/analytics";

const Footer = () => {
  return (
    <div
      className="lime-footer"
      style={{
        width: "100%",
        backgroundColor: "#CFD1E6",
        padding: "30px",
      }}
    >
      <section
        className="contact-details container pt-10 pb-10"
        style={{ padding: "30px 0" }}
        id="contact-details-section"
      >
        <div className="row text-center text-md-left ">
          <div className="col-12 col-md-6 col-lg-4 grid-margin">
            <img src={KW_LOGO} alt="" width={175} className="pb-2" />
            <div className="pt-2">
              <a
                className="text-muted m-0"
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                href={`mailto:${officeContactDetails[0].emailId}`}
                onClick={() =>
                  trackEvent(AnalyticsEvents.CLICK, {
                    category: "contact",
                    label: "email",
                  })
                }
              >
                {officeContactDetails[0].emailId}
              </a>
              <br />
              <a
                className="text-muted m-0"
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                href={`tel:${officeContactDetails[0].phone}`}
                onClick={() =>
                  trackEvent(AnalyticsEvents.CLICK, {
                    category: "contact",
                    label: "phone",
                  })
                }
              >
                {officeContactDetails[0].phone}
              </a>
            </div>
          </div>
          {/* <div className="col-12 col-md-6 col-lg-3 grid-margin">
            <h5 className="pb-2">Get in Touch</h5>
            <p className="text-muted">
              Don’t miss any updates of our new features and so on.!
            </p>
            <form>
              <input
                type="text"
                className="form-control"
                id="Email"
                placeholder="Email id"
                defaultValue={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
              />
            </form>
            <div className="pt-3">
              <button
                className="btn btn-dark"
                onClick={() =>
                  subscribe(emailAddress)
                    .then((response) => {
                      console.log("response:", response);
                      setEmailAddress("");
                    })
                    .catch((err) => {
                      console.log(err);
                      setEmailAddress("");
                    })
                }
              >
                Subscribe
              </button>
            </div>
          </div> */}
          <div
            className="col-12 col-md-6 col-lg-4 grid-margin"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <h5 className="pb-2">Our Guidelines</h5>
            <Link
              to={Links.terms}
              className="m-0 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Terms & Conditions
            </Link>
            <Link
              to={Links.privacy}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Privacy policy
            </Link>
            <Link
              to={Links.gotralu}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Gotralu
            </Link>
            <Link
              to={Links.nakshatraRashiList}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Nakshatra &amp; Rashi List
            </Link>
            {/* <a
              href={Links.cookie}
              style={{
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              <p className="m-0 pt-1 pb-2">Cookie Policy</p>
            </a>
            <a href="#">
              <p className="m-0 pt-1">Discover</p>
            </a> */}
          </div>
          <div className="col-12 col-md-6 col-lg-4 grid-margin">
            <h5 className="pb-2">Our address</h5>
            <p className="text-muted">
              {officeContactDetails[0].addressFirstLine}
              <br />
              {officeContactDetails[0].city} - {officeContactDetails[0].pinCode}
              .
            </p>
            <SocialLinks />
          </div>
        </div>
      </section>
      <footer className="border-top">
        <p className="text-center text-muted pt-4">
          {COPYRIGHT_SYMBOL}
          <a
            href={KALYANAWARAN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-1"
          >
            {WEBSITE_NAME}.
          </a>
          {RIGHT_RESERVED}.
        </p>
        <p className="text-center text-muted pb-4">
          Made with <HeartIcon style={{ color: "red" }} /> by
          <a
            href={COMPANY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-1"
            onClick={() =>
              trackEvent(AnalyticsEvents.OUTBOUND_CLICK, {
                url: COMPANY_URL,
                type: "company_link",
              })
            }
          >
            {COMPANY_NAME}.
          </a>
        </p>
      </footer>
    </div>
  );
};

export default Footer;
